import React, { useEffect, useState } from 'react';
import { Switch } from '@mui/material';

const SwitchCell = ({ item, checked, onClick, ...props }) => {

    const [checkedVal, setChecked] = useState(checked);

    // Update the local checked state if the checked prop changes
    useEffect(() => {
        setChecked(checked);
    }, [checked]);  // This effect runs when the "checked" prop changes

    return (
        <div style={{ textAlign: "center" }}>
            <Switch
                checked={checkedVal}  // Use the local checked state
                size="small"
                onClick={async () => {
                    if (onClick) {
                        const result = await onClick(item, !checkedVal); // Call parent function and await its result
                        if (result) {
                            setChecked(!checkedVal); // Update local state only if the result is true
                        }
                    }
                }}
                {...props}  // Spread all additional props to the Switch
            />
        </div>
    );
};

export default SwitchCell;
